'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var categoryOptionGroupSetsInit = exports.categoryOptionGroupSetsInit = undefined;

exports.categoryOptionGroupSetsInit = categoryOptionGroupSetsInit = function categoryOptionGroupSetsInit(c) {
    var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var t = this,
        appManager = c.appManager,
        requestManager = c.requestManager,
        dimensionConfig = c.dimensionConfig,
        apiPath = appManager.getApiPath(),
        displayPropertyUrl = appManager.getDisplayPropertyUrl();

    return {
        baseUrl: apiPath + '/categoryOptionGroupSets.json',
        params: ['fields=id,' + displayPropertyUrl + ',dataDimensionType', 'paging=false'].concat(extraParams),
        success: function success(r) {
            appManager.addCategoryOptionGroupSets(r.categoryOptionGroupSets);

            requestManager.ok(this);
        }
    };
};
//# sourceMappingURL=categoryOptionGroupSetsInit.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/init/categoryOptionGroupSetsInit.js
 ** module id = 126
 ** module chunks = 0 1
 **/